import React from 'react';
import { string } from 'prop-types';
import { isExternalLink } from '../../utils/url';

function ExperientialLearningCard({
  Url: url,
  Heading: heading,
  Location: location,
  Teaser: teaser,
  TypeOfExperience: typeOfExperience,
  externalLinkText
}) {
  const isExternal = isExternalLink(url);

  return (
    <a href={url}
      className={`program-result-card hover-card ${isExternal ? 'faculty-staff-listing__external-card' : ''}`}
      target={isExternal ? '_blank' : null}
      rel={isExternal ? 'noopener noreferrer' : null}
    >
      {isExternal && <span className="visually-hidden">{externalLinkText}</span>}
      <h3 className="program-result-card__program-name">{heading}</h3>
      <div className="program-result-card__description">
        <p className="program-result-card__program-degree">
          <strong>{location}</strong>
        </p>
        <p className="program-result-card__on-campus">{typeOfExperience}</p>
      </div>
      <p className="program-result-card__teaser">{teaser}</p>
      <p className="program-result-card__on-campus program-result-card__on-campus--floating">
        {typeOfExperience}
      </p>
    </a>
  );
}

ExperientialLearningCard.propTypes = {
  Url: string.isRequired,
  Heading: string.isRequired,
  Location: string.isRequired,
  Teaser: string.isRequired,
  TypeOfExperience: string.isRequired,
  externalLinkText: string.isRequired
};

export default React.memo(ExperientialLearningCard);
